import React, { useState } from "react";
import routes from '../api/index';
import {Redirect} from 'react-router-dom'
import Navbar from './navbar'

const Register = () => {
    const [username, setUsername] = useState()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState()
    const [confirmPassword, setConfirmPassword] = useState()
    const [done, setDone] = useState(false)

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function handleRegister() {
        if (username && email && password && confirmPassword) {
            if (!validateEmail(email)) {
                alert("Please enter a proper email!")
                return
            }

            if (password === confirmPassword ) {
                const info = {
                    username: username,
                    email: email,
                    password: password,
                }
                
                routes.register(info)
                    .then(res => res.data.message)
                    .then((prev) => {
                        if (prev === "Registration Successful"){
                            alert("Registration Successful")
                            setDone(true)
                        }
                        else if(prev === "Registration not Successful"){
                            console.log("Registration not Successful")
                        }
                    })
            }
                else alert("Passwords do not match")
                
        }
        else alert("Please fill out all fields to register!")
    }

    if (done)
        return <Redirect to='/' />
    else
        return <div className="">
                    <Navbar loggedIn={false}/>
                    <div id="register-screen" className="h-screen grid grid-rows-6 justify-center">
                        <div id="introduction" className="text-2xl grid place-items-center text-center row-start-2">
                            <h1 id="login-title">Register</h1>
                        </div>
                        <div id="register-wrapper" className="grid place-items-center row-start-3">
                            <div className="p-3 rounded-lg border-0 h-full w-11/12 grid place-items-center justify-center">
                                <div id="register-form">
                                    <label>Username</label><br/>
                                    <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="text" onChange ={e => setUsername(e.target.value)} /><br/>
                                    <label>Email</label><br/>
                                    <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="text" onChange ={e => setEmail(e.target.value)} /><br/>
                                    <label>Password</label><br/>
                                    <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="password" onChange = {e => setPassword(e.target.value)} /><br/>
                                    <label>Confirm Password</label><br/>
                                    <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="password" onChange = {e => setConfirmPassword(e.target.value)} /><br/>
                                    <button className="focus:outline-none border border-white p-1 hover:bg-red-300 hover:border-transparent transition-all" onClick={handleRegister}> Register </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                
}

export default Register